module.exports = __webpack_public_path__ + "static/media/Expand.190245bd.svg";